function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    edit\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.84,31.8a1.1,1.1,0,0,1-.75-.31L9.14,25.54a1.06,1.06,0,0,1,0-1.51L24.6,8.57A5.28,5.28,0,0,1,32.06,16L16.6,31.49A1.1,1.1,0,0,1,15.84,31.8Zm-4.43-7,4.43,4.44,14.71-14.7a3.14,3.14,0,0,0-4.44-4.44Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 11.01,
  y: 24.32,
  width: 2.17,
  height: 8.41,
  transform: "translate(-16.63 16.91) rotate(-45)",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.31,33.34a1.07,1.07,0,0,1-.76-.32l-6-5.94a1.08,1.08,0,0,1-.31-.76,1.06,1.06,0,0,1,.31-.75L9.14,24a1.06,1.06,0,0,1,1.51,0l6,5.95a1.06,1.06,0,0,1,.31.75,1.08,1.08,0,0,1-.31.76L15.06,33A1.06,1.06,0,0,1,14.31,33.34Zm-4.44-7,4.44,4.44,0,0L9.9,26.29Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  points: "8.66 34.33 14.31 32.27 8.36 26.32 6.3 31.97 8.66 34.33",
  fill: "#231f20"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.66,35.4a1.07,1.07,0,0,1-.76-.32L5.54,32.72a1.08,1.08,0,0,1-.25-1.12L7.36,26a1.06,1.06,0,0,1,1.75-.39l6,5.94a1.07,1.07,0,0,1,.29,1,1.08,1.08,0,0,1-.68.77L9,35.33A.89.89,0,0,1,8.66,35.4ZM7.53,31.7l1.4,1.39,3.44-1.25L8.79,28.26Z",
  fill: "#231f20"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 24.61,
  y: 10.75,
  width: 2.14,
  height: 8.41,
  transform: "translate(-3.05 22.53) rotate(-45)",
  fill: "#231f20"
});

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default SvgEdit;